import { observer } from 'mobx-react';
import MapPreview from '../../components/MapPreview/MapPreview';
import branchEditStore from '../../store/branchEditStore';
import integrationsStore from 'src/mobx/integrationStore';
import { LatLng } from 'src/types/main';
import { isDisabledByPos } from 'src/utils/helpers';
import AddressSearch from 'src/view/components/AddressSearch/AddressSearch';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import IntegrationTooltip from 'src/view/components/IntegrationTooltip/IntegrationTooltip';
import Text from 'src/view/components/Text/Text';
import './style.scss';

const Location = observer((): JSX.Element => {
  const onSelectAddress = (address: string, location?: LatLng) => {
    branchEditStore.changeBranchData({ address, latitude: location?.lat, longitude: location?.lng });
  };

  const branchAddressRestrictionAccess = integrationsStore.posRestrictions?.branchAddress;
  const isBranchAddressDisabledByPos = isDisabledByPos(branchAddressRestrictionAccess);

  const { address: isValid } = branchEditStore.validation.details;

  return (
    <div className="branch-location">
      <Text type="block-header" text="branch_location_block_header" className="mb-4" />

      {/* branch address */}
      <IntegrationManager setting={branchAddressRestrictionAccess} wrapperClassName="d-flex flex-column mb-3">
        <Text type="block-header" text="branch_address" disabled={isBranchAddressDisabledByPos} required className="mb-2" />
        <IntegrationTooltip isVisible={isBranchAddressDisabledByPos}>
          <AddressSearch
            value={branchEditStore.editableBranch.address}
            onChangeAddress={onSelectAddress}
            placeholder="type_in_branch_address"
            validation={{ isValid, errorText: isValid ? undefined : 'required_field_error' }}
            selectionOnEmptyValue
            className="full-width"
            listWrapperClassName="branch-location__addresses-list"
          />
        </IntegrationTooltip>
      </IntegrationManager>

      {/* Mini map for preview */}
      <IntegrationManager setting={branchAddressRestrictionAccess} withTooltip>
        <MapPreview />
      </IntegrationManager>
    </div>
  );
});

export default Location;
